import keys from 'lodash/keys';
import includes from 'lodash/includes';
import isObject from 'lodash/isObject';
import get from 'lodash/get';
import { actionWith, callApi, apiActionTypes } from './utils';
import { CALL_API, METHODS } from './constants';
import AuthManager from '../utils/AuthManager';
import { history } from '../../src/store';

// expose for general purpose use
export { CALL_API, METHODS, apiActionTypes };

export default store => next => action => {
    const callAPI = action[CALL_API];
    if (typeof callAPI === 'undefined') {
        return next(action);
    }
    const { types, requestConfig } = callAPI;

    if (!isObject(types) || keys(types).length !== 3) {
        throw new Error('Expected an object with of three action types.');
    }

    if (!isObject(requestConfig)) {
        throw new Error('Expected an object api request config.');
    }

    if (!keys(types).every(type => typeof types[type] === 'string')) {
        throw new Error('Expected action types to be strings.');
    }

    const { request: requestType, success: successType, failure: failureType } = types;

    next(
        actionWith(requestConfig, {
            type: requestType,
            ...action,
        })
    );

    return callApi(requestConfig)
        .then(response => {
            const nextAction = actionWith(requestConfig, {
                type: successType,
                payload: response,
                ...action,
            });
            next(nextAction);
            return Promise.resolve(nextAction);
        })
        .catch(exception => {
            const error = get(exception, 'response', {});
            if (error.status === 401 || error.status === 302) {
                next(
                    actionWith(requestConfig, {
                        type: failureType,
                        payload: error.data,
                    })
                );
                AuthManager.remove();
                AuthManager.removeGuestToken();
                AuthManager.removeAnonymousUserId();
                error.status === 401
                    ? history.push('/shop/customer/login')
                    : history.push('/shop/customer/forgot-password');
                return Promise.reject();
            }
            const errorMessage = error.data || exception.message || 'Something went wrong';
            next(
                actionWith(requestConfig, {
                    type: failureType,
                    payload: errorMessage,
                })
            );
            return Promise.reject(exception);
        });
};
